/**
 *Preneed stepper steps
 *
 * @export
 */
export enum PreneedStepperSteps {
  Rate = 0,
  Replacement = 1,
  ProposedInsured = 2,
  SecondaryAddressee = 3,
  OwnerInformation = 4,
  Beneficiary = 5,
  CurrentPhysician = 6,
  PaymentInformation = 7,
  AgentInformation = 8,
  ReviewAndSign = 9,
  Confirmation = 10
}
